import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="border-t py-16 md:py-20"
      style={{ borderColor: "var(--ll-border)", background: "var(--ll-bg-secondary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl font-semibold mb-4" style={{ color: "var(--ll-text)" }}>
              The Lemonade Living Co.
            </h3>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
              Turning life&apos;s lemons into moments of growth, strength, and joy. Supporting your mental wellbeing journey.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase mb-4 font-medium" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
              Quick Links
            </h4>
            <div className="space-y-3">
              {[
                { label: "Home", to: "/" },
                { label: "About", to: "/about" },
                { label: "Shop", to: "/shop" },
                { label: "Blog", to: "/blog" },
              ].map((link) => (
                <Link key={link.to} to={link.to} data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="block text-sm transition-colors duration-300 hover:opacity-70"
                  style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase mb-4 font-medium" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
              Get In Touch
            </h4>
            <a href="mailto:lemonadeliving4me@gmail.com" data-testid="footer-email"
              className="text-sm transition-colors duration-300 hover:opacity-70"
              style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
              lemonadeliving4me@gmail.com
            </a>
            <p className="text-sm mt-2" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
              South Africa
            </p>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-12 flex flex-wrap gap-6 justify-center md:justify-start">
          <Link to="/privacy" data-testid="footer-link-privacy"
            className="text-xs transition-colors duration-300 hover:opacity-70"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
            Privacy Notice
          </Link>
          <Link to="/terms" data-testid="footer-link-terms"
            className="text-xs transition-colors duration-300 hover:opacity-70"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
            Terms &amp; Conditions
          </Link>
        </div>

        <div className="mt-8 pt-8 border-t flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderColor: "var(--ll-border)" }}>
          <p className="text-xs flex items-center gap-1" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
            Made with <Heart size={12} style={{ color: "var(--ll-accent)" }} /> by The Lemonade Living Company
          </p>
          <p className="text-xs" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
